var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_646_20451)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_646_20451",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 170,
    height: 170
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.667 0H11.3333C5.07411 0 0 5.07411 0 11.3333V158.667C0 164.926 5.07411 170 11.3333 170H158.667C164.926 170 170 164.926 170 158.667V11.3333C170 5.07411 164.926 0 158.667 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_646_20451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.667 0H11.3333C5.07411 0 0 5.07411 0 11.3333V158.667C0 164.926 5.07411 170 11.3333 170H158.667C164.926 170 170 164.926 170 158.667V11.3333C170 5.07411 164.926 0 158.667 0Z",
    fill: "#001965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.279 118.619H123.053V89.6026H96.3924V118.619H82.167V51.354H96.3924V77.7323H123.053V51.354H137.279V118.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_646_20451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5251 84.3542C88.5251 95.7222 85.2908 104.295 78.8216 110.073C72.3531 115.789 63.3402 118.646 51.784 118.646H32.7539V51.3813H53.8566C60.8908 51.3813 66.983 52.6374 72.1328 55.1497C77.3462 57.6619 81.3653 61.3674 84.1915 66.2663C87.0808 71.165 88.5251 77.1944 88.5251 84.3542ZM73.7344 84.731C73.7344 77.3197 72.1017 71.8557 68.8357 68.3388C65.5699 64.8218 60.828 63.0632 54.6102 63.0632H46.9794V106.87H53.1029C66.8573 106.87 73.7344 99.4906 73.7344 84.731Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.292 77.5625H123.057V92.4375H101.292V77.5625Z",
    fill: "#89C0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3955 76.854H102V92.4373H96.3955V76.854Z",
    fill: "#001965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7285 71.896H47.1008V98.1043H32.7285V71.896Z",
    fill: "#001965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7607 77.5625H46.9665L46.9713 92.4375H32.7607V77.5625Z",
    fill: "#89C0EB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.667 1.0625H11.3333C5.66091 1.0625 1.0625 5.66091 1.0625 11.3333V158.667C1.0625 164.339 5.66091 168.938 11.3333 168.938H158.667C164.339 168.938 168.938 164.339 168.938 158.667V11.3333C168.938 5.66091 164.339 1.0625 158.667 1.0625Z",
    stroke: "#001965",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_646_20451",
    x: 21.7539,
    y: 41.3813,
    width: 79.7715,
    height: 91.2646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0980392 0 0 0 0 0.396078 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_646_20451"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_646_20451",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_646_20451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhLogo);
export default __webpack_public_path__ + "static/media/DH_logo.ff66809c18a481eafb9249ef5f157777.svg";
export { ForwardRef as ReactComponent };